const buildMediaUrl = (uri) => {
    if (process.env.NODE_ENV === 'development') {
        return `${process.env.REACT_APP_BACKEND_URL_DEV}${uri}`
    } else {
        return `${process.env.REACT_APP_BACKEND_URL_PRO}${uri}`
    }
}

export default buildMediaUrl
